// ============================================
// SEO DATA - RICH CONTENT FOR AGENCY WEBSITE
// ============================================

export const SEO_SERVICES = {
  'creation-web': {
    metaTitle: "Création de Site Internet à Istres | Sites Vitrines & E-commerce | Agence MSC",
    metaDescription: "Agence web à Istres spécialisée en création de sites internet, e-commerce WordPress & WooCommerce. Devis gratuit. +200 sites créés depuis 2012.",
    heroTitle: "Création de Site Internet",
    heroSubtitle: "Votre présence digitale sur-mesure",
    heroDescription: "Nous concevons des sites web performants, optimisés SEO et pensés pour convertir vos visiteurs en clients. Du site vitrine au e-commerce complet.",
    
    // Rich content sections
    introduction: {
      title: "Pourquoi créer un site internet professionnel ?",
      content: `Dans un monde où 81% des consommateurs recherchent en ligne avant d'acheter, avoir un site web professionnel n'est plus une option, c'est une nécessité. 
      
Un site internet bien conçu est votre commercial disponible 24h/24, 7j/7. Il renforce votre crédibilité, élargit votre zone de chalandise et vous permet de toucher des clients que vous n'auriez jamais pu atteindre autrement.

Chez MSC, nous créons des sites qui ne sont pas seulement beaux – ils sont stratégiquement conçus pour atteindre vos objectifs business.`,
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800",
      stats: [
        { value: "81%", label: "des consommateurs recherchent en ligne" },
        { value: "75%", label: "jugent la crédibilité sur le design" },
        { value: "3s", label: "pour convaincre un visiteur" }
      ]
    },

    // Why WordPress section
    whyWordPress: {
      title: "Pourquoi choisir WordPress pour votre site ?",
      subtitle: "Le CMS qui propulse 43% du web mondial",
      content: `WordPress n'est pas qu'un simple outil de blog – c'est le système de gestion de contenu le plus puissant et le plus flexible au monde. Voici pourquoi nous le recommandons :`,
      reasons: [
        {
          icon: "Zap",
          title: "Facilité de gestion",
          description: "Interface intuitive pour modifier vos contenus sans connaissances techniques. Ajoutez des pages, des articles, des images en quelques clics."
        },
        {
          icon: "Search",
          title: "SEO-Friendly natif",
          description: "Structure optimisée pour le référencement naturel. Avec les bons plugins (Yoast, Rank Math), dominez les résultats Google."
        },
        {
          icon: "Puzzle",
          title: "+60 000 plugins",
          description: "Réservation en ligne, paiement, newsletter, chat... Tout est possible grâce à l'écosystème WordPress."
        },
        {
          icon: "Smartphone",
          title: "100% Responsive",
          description: "Tous nos thèmes sont parfaitement adaptés mobile, tablette et desktop pour une expérience utilisateur optimale."
        },
        {
          icon: "Shield",
          title: "Sécurité renforcée",
          description: "Mises à jour régulières, plugins de sécurité, certificat SSL... Votre site est entre de bonnes mains."
        },
        {
          icon: "TrendingUp",
          title: "Évolutif à l'infini",
          description: "Commencez petit, grandissez grand. WordPress évolue avec votre entreprise sans limite."
        }
      ],
      video: "https://www.youtube.com/embed/jmqu4HC3zmo",
      cta: "Découvrez nos réalisations WordPress"
    },

    // E-commerce features
    ecommerceFeatures: {
      title: "Fonctionnalités de votre Boutique en Ligne",
      subtitle: "Tout ce dont vous avez besoin pour vendre en ligne",
      categories: [
        {
          name: "Gestion des Produits",
          icon: "Package",
          features: [
            "Catalogue produits illimité",
            "Variations (taille, couleur, options)",
            "Gestion des stocks automatique",
            "Produits téléchargeables",
            "Produits virtuels / services",
            "Import/export CSV en masse",
            "Étiquettes et catégories",
            "Produits à la une"
          ]
        },
        {
          name: "Paiements & Checkout",
          icon: "CreditCard",
          features: [
            "Paiement CB (Stripe, PayPal)",
            "Paiement en 3x/4x sans frais",
            "Virement bancaire",
            "Paiement à la livraison",
            "Checkout en une page",
            "Panier persistant",
            "Codes promo & réductions",
            "Carte cadeau"
          ]
        },
        {
          name: "Livraison & Logistique",
          icon: "Truck",
          features: [
            "Tarifs par zone/poids",
            "Click & Collect",
            "Livraison gratuite conditionnelle",
            "Suivi des colis intégré",
            "Points relais (Mondial Relay)",
            "Chronopost / Colissimo",
            "Gestion des retours",
            "Étiquettes d'expédition"
          ]
        },
        {
          name: "Marketing & Conversion",
          icon: "Target",
          features: [
            "Emails automatiques",
            "Relance panier abandonné",
            "Ventes croisées (cross-sell)",
            "Produits suggérés (up-sell)",
            "Programme de fidélité",
            "Avis clients vérifiés",
            "Wishlist / Liste d'envies",
            "Partage réseaux sociaux"
          ]
        },
        {
          name: "Gestion & Administration",
          icon: "Settings",
          features: [
            "Tableau de bord complet",
            "Statistiques de ventes",
            "Gestion des commandes",
            "Export comptable",
            "Multi-devises",
            "Multi-langues",
            "Gestion des taxes (TVA)",
            "Factures PDF automatiques"
          ]
        },
        {
          name: "SEO & Performance",
          icon: "Search",
          features: [
            "URLs optimisées SEO",
            "Balises meta produits",
            "Schema.org Rich Snippets",
            "Images optimisées (WebP)",
            "Cache & CDN intégré",
            "Score PageSpeed 90+",
            "AMP pour mobile",
            "Sitemap XML automatique"
          ]
        }
      ]
    },

    // Sales levers
    salesLevers: {
      title: "Les Leviers pour Booster vos Ventes",
      subtitle: "Stratégies éprouvées pour maximiser votre chiffre d'affaires",
      levers: [
        {
          icon: "Clock",
          title: "Urgence & Rareté",
          description: "Compteurs de temps, stocks limités, offres flash... Créez le sentiment d'urgence qui pousse à l'action.",
          examples: ["Compte à rebours sur les offres", "\"Plus que 3 en stock\"", "Ventes privées limitées"]
        },
        {
          icon: "Users",
          title: "Preuve Sociale",
          description: "Avis clients, témoignages, nombre de ventes... Montrez que d'autres vous font confiance.",
          examples: ["Avis Google intégrés", "\"1500 clients satisfaits\"", "Logos clients partenaires"]
        },
        {
          icon: "Gift",
          title: "Incentives & Bonus",
          description: "Offrez de la valeur ajoutée pour déclencher l'achat et augmenter le panier moyen.",
          examples: ["Livraison offerte dès 50€", "Cadeau avec chaque commande", "-10% première commande"]
        },
        {
          icon: "MessageCircle",
          title: "Chat & Support",
          description: "Répondez instantanément aux questions et levez les objections en temps réel.",
          examples: ["Chat en direct", "WhatsApp Business", "FAQ intelligente"]
        },
        {
          icon: "RefreshCw",
          title: "Garanties & Rassurance",
          description: "Éliminez les freins à l'achat avec des garanties solides.",
          examples: ["Satisfait ou remboursé 30j", "Paiement sécurisé", "Retours gratuits"]
        },
        {
          icon: "Zap",
          title: "Simplification",
          description: "Moins de clics = plus de conversions. Simplifiez le parcours d'achat.",
          examples: ["Achat en 1 clic", "Auto-complétion adresse", "Paiement Apple/Google Pay"]
        }
      ]
    },

    // FAQ
    faq: [
      {
        question: "Combien coûte la création d'un site internet ?",
        answer: "Le prix varie selon vos besoins : un site vitrine démarre à partir de 1 500€, un site e-commerce à partir de 3 000€. Nous établissons un devis gratuit et personnalisé après analyse de votre projet. Nos tarifs incluent le design, le développement, l'optimisation SEO et la formation."
      },
      {
        question: "Combien de temps pour créer mon site ?",
        answer: "En moyenne, comptez 2 à 4 semaines pour un site vitrine et 4 à 8 semaines pour un e-commerce. Ce délai peut varier selon la complexité du projet et votre réactivité pour les retours. Nous vous fournissons un planning détaillé dès le début du projet."
      },
      {
        question: "Pourrai-je modifier mon site moi-même ?",
        answer: "Absolument ! Tous nos sites sont livrés avec une interface d'administration intuitive (WordPress). Nous incluons une formation personnalisée pour vous rendre autonome : ajout de pages, modification de textes, ajout de produits... Tout devient simple !"
      },
      {
        question: "Mon site sera-t-il bien référencé sur Google ?",
        answer: "Oui, tous nos sites sont optimisés SEO dès la conception : structure technique parfaite, balises meta, vitesse de chargement, responsive design... Nous pouvons également vous accompagner avec une stratégie SEO complète pour dominer votre marché local."
      },
      {
        question: "Proposez-vous l'hébergement et la maintenance ?",
        answer: "Oui ! Nous proposons des forfaits tout inclus : hébergement haute performance, mises à jour de sécurité, sauvegardes quotidiennes, support technique réactif et modifications mineures. Concentrez-vous sur votre métier, on s'occupe du reste."
      },
      {
        question: "Pouvez-vous reprendre/refondre mon site existant ?",
        answer: "Bien sûr ! Nous réalisons régulièrement des refontes de sites existants. Nous analysons votre site actuel, conservons ce qui fonctionne, et modernisons le reste. Migration de contenu, redirection SEO... Tout est géré proprement."
      }
    ],

    // Gallery images
    gallery: [
      { src: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800", alt: "Design web moderne" },
      { src: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800", alt: "Dashboard analytics" },
      { src: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800", alt: "E-commerce mobile" },
      { src: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=800", alt: "UX Design process" },
      { src: "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800", alt: "Développement web" },
      { src: "https://images.unsplash.com/photo-1522542550221-31fd8575f5c8?w=800", alt: "Responsive design" }
    ],

    // Videos
    videos: [
      { title: "Comment créer un site e-commerce performant", url: "https://www.youtube.com/embed/dQw4w9WgXcQ", duration: "12:34" },
      { title: "WordPress vs autres CMS : le comparatif", url: "https://www.youtube.com/embed/dQw4w9WgXcQ", duration: "8:45" }
    ]
  },

  'creation-graphique': {
    metaTitle: "Création Graphique & Logo à Istres | Identité Visuelle | Agence MSC",
    metaDescription: "Agence de création graphique à Istres. Logos, chartes graphiques, visuels print & web. +500 créations depuis 2012. Devis gratuit.",
    heroTitle: "Création Graphique",
    heroSubtitle: "Donnez une identité unique à votre marque",
    heroDescription: "Logo, charte graphique, supports print et digitaux... Nous créons l'univers visuel qui vous ressemble et marque les esprits.",

    introduction: {
      title: "L'importance d'une identité visuelle forte",
      content: `Votre identité visuelle est le premier contact avec vos clients. En moins de 3 secondes, ils se forgent une opinion sur votre entreprise. Une identité forte et cohérente :

• Renforce instantanément votre crédibilité
• Vous différencie de la concurrence  
• Crée un lien émotionnel avec votre audience
• Facilite la mémorisation de votre marque

Chez MSC, nous ne créons pas juste des logos – nous construisons des identités de marque qui racontent votre histoire et portent vos valeurs.`,
      image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800",
      stats: [
        { value: "3s", label: "pour faire bonne impression" },
        { value: "80%", label: "reconnaissent une marque par sa couleur" },
        { value: "+500", label: "logos créés par notre équipe" }
      ]
    },

    methodology: {
      title: "Notre Méthode de Création",
      subtitle: "Un processus créatif rigoureux en 6 étapes",
      steps: [
        {
          number: 1,
          title: "Brief & Découverte",
          description: "Nous plongeons dans votre univers : vos valeurs, votre cible, vos concurrents, vos aspirations. Ce brief approfondi est la fondation de tout le projet.",
          duration: "1-2 jours"
        },
        {
          number: 2,
          title: "Recherches & Inspirations",
          description: "Notre équipe explore les tendances, analyse votre secteur et crée des moodboards pour définir la direction créative.",
          duration: "2-3 jours"
        },
        {
          number: 3,
          title: "Esquisses & Concepts",
          description: "Crayons en main, nous générons des dizaines d'idées. Les meilleures sont développées en concepts aboutis.",
          duration: "3-5 jours"
        },
        {
          number: 4,
          title: "Présentation",
          description: "Nous vous présentons 3 pistes créatives distinctes, avec les rationnels et mises en situation pour chaque concept.",
          duration: "1 jour"
        },
        {
          number: 5,
          title: "Affinage",
          description: "Votre concept préféré est peaufiné selon vos retours. Couleurs, typographies, détails... Tout est ajusté à la perfection.",
          duration: "2-3 jours"
        },
        {
          number: 6,
          title: "Livraison",
          description: "Vous recevez tous les fichiers sources et formats d'export, accompagnés d'un guide d'utilisation de votre identité.",
          duration: "1 jour"
        }
      ]
    },

    deliverables: {
      title: "Livrables Inclus",
      items: [
        { name: "Fichiers sources", description: "AI, PSD, PDF éditables", icon: "File" },
        { name: "Formats d'export", description: "PNG, JPG, SVG, EPS", icon: "Download" },
        { name: "Déclinaisons", description: "Couleur, N&B, monochrome", icon: "Layers" },
        { name: "Guide de marque", description: "Règles d'utilisation", icon: "Book" },
        { name: "Typographies", description: "Polices officielles", icon: "Type" },
        { name: "Palette couleurs", description: "Codes Pantone, CMJN, RVB, Hex", icon: "Palette" }
      ]
    },

    faq: [
      {
        question: "Combien coûte la création d'un logo ?",
        answer: "Nos logos démarrent à 490€ pour un logo simple, et jusqu'à 1 500€+ pour une identité visuelle complète avec charte graphique. Le tarif dépend de la complexité et des livrables souhaités."
      },
      {
        question: "Combien de propositions vais-je recevoir ?",
        answer: "Nous présentons systématiquement 3 pistes créatives distinctes. Vous choisissez celle qui vous parle le plus, et nous l'affinons ensemble jusqu'à la perfection."
      },
      {
        question: "Combien de modifications sont incluses ?",
        answer: "Nous incluons 3 tours de modifications dans nos forfaits. Notre expérience montre que c'est généralement suffisant pour atteindre le résultat parfait."
      },
      {
        question: "Serai-je propriétaire de mon logo ?",
        answer: "Oui, à 100%. Une fois le projet finalisé et réglé, tous les droits de propriété intellectuelle vous sont cédés. Le logo est à vous, pour toujours."
      },
      {
        question: "Pouvez-vous moderniser mon logo existant ?",
        answer: "Absolument ! Nous réalisons des refontes et modernisations de logos existants. Nous conservons l'ADN de votre marque tout en lui donnant un coup de frais."
      }
    ],

    gallery: [
      { src: "https://images.unsplash.com/photo-1626785774625-0b1c2c4eab67?w=800", alt: "Création de logo" },
      { src: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=800", alt: "Branding design" },
      { src: "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=800", alt: "Charte graphique" },
      { src: "https://images.unsplash.com/photo-1572044162444-ad60f128bdea?w=800", alt: "Design print" }
    ]
  },

  'creation-video': {
    metaTitle: "Production Vidéo d'Entreprise à Istres | Vidéo Corporate | Agence MSC",
    metaDescription: "Agence de production vidéo à Istres. Vidéos corporate, interviews, motion design, réseaux sociaux. Équipe professionnelle. Devis gratuit.",
    heroTitle: "Production Vidéo",
    heroSubtitle: "Racontez votre histoire en images",
    heroDescription: "Vidéo corporate, interview, motion design, contenu réseaux sociaux... Captez l'attention et transmettez votre message avec impact.",

    introduction: {
      title: "La vidéo : le format roi du digital",
      content: `La vidéo représente 82% du trafic internet mondial. Sur les réseaux sociaux, elle génère 1200% plus de partages que les textes et images combinés.

Pourquoi la vidéo est-elle si puissante ?
• Elle capte l'attention instantanément
• Elle transmet des émotions mieux que tout autre format
• Elle est mémorisée 6x plus longtemps qu'un texte
• Elle booste les conversions de 80% sur une landing page

Notre équipe de vidéastes et motion designers crée des contenus qui marquent, émeuvent et convertissent.`,
      image: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800",
      stats: [
        { value: "82%", label: "du trafic web est de la vidéo" },
        { value: "x6", label: "plus mémorisée qu'un texte" },
        { value: "+80%", label: "de conversions avec vidéo" }
      ]
    },

    videoTypes: {
      title: "Nos Types de Vidéos",
      types: [
        {
          name: "Vidéo Corporate",
          description: "Présentez votre entreprise, vos valeurs, votre équipe. Idéale pour votre site web et vos présentations commerciales.",
          duration: "2-5 min",
          price: "À partir de 1 500€",
          image: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=600"
        },
        {
          name: "Interview & Témoignage",
          description: "Donnez la parole à vos clients, collaborateurs ou experts. La preuve sociale la plus puissante.",
          duration: "1-3 min",
          price: "À partir de 800€",
          image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600"
        },
        {
          name: "Motion Design",
          description: "Expliquez des concepts complexes avec des animations claires et engageantes. Parfait pour les produits tech/SaaS.",
          duration: "30s-2 min",
          price: "À partir de 1 200€",
          image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=600"
        },
        {
          name: "Contenu Social Media",
          description: "Reels, TikTok, Stories... Du contenu court et percutant optimisé pour chaque plateforme.",
          duration: "15-60s",
          price: "À partir de 400€",
          image: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=600"
        }
      ]
    },

    equipment: {
      title: "Notre Équipement Pro",
      items: [
        "Caméras 4K Cinema (Sony FX6, Canon C70)",
        "Optiques cinéma & photo (Sigma Art, Canon L)",
        "Stabilisateurs motorisés (DJI RS3 Pro)",
        "Drones homologués (DJI Mavic 3 Pro)",
        "Éclairage studio LED (Aputure, Nanlite)",
        "Micros broadcast (Sennheiser, Rode)",
        "Suite de montage complète (DaVinci, Premiere)"
      ]
    },

    faq: [
      {
        question: "Quel est le délai pour une vidéo ?",
        answer: "Comptez 2 à 4 semaines selon la complexité : 1 semaine de pré-production, 1-2 jours de tournage, 1-2 semaines de post-production. Pour les urgences, nous avons des formules accélérées."
      },
      {
        question: "Fournissez-vous les acteurs ?",
        answer: "Oui si nécessaire ! Nous travaillons avec un réseau de comédiens professionnels. Mais souvent, vos vrais collaborateurs sont les meilleurs ambassadeurs de votre marque."
      },
      {
        question: "Combien de modifications sont possibles ?",
        answer: "Nos forfaits incluent 2 tours de modifications sur le montage. Au-delà, nous facturons à l'heure. Mais avec notre process de validation par étapes, on atteint généralement le résultat parfait rapidement."
      }
    ],

    gallery: [
      { src: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800", alt: "Tournage vidéo" },
      { src: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800", alt: "Making-of" },
      { src: "https://images.unsplash.com/photo-1536240478700-b869070f9279?w=800", alt: "Drone" }
    ]
  },

  'marketing-digital': {
    metaTitle: "Marketing Digital & SEO à Istres | Référencement Google | Agence MSC",
    metaDescription: "Agence de marketing digital à Istres. SEO, Google Ads, réseaux sociaux, email marketing. Boostez votre visibilité. Audit gratuit.",
    heroTitle: "Marketing Digital",
    heroSubtitle: "Développez votre visibilité en ligne",
    heroDescription: "SEO, publicité en ligne, réseaux sociaux, email marketing... Des stratégies d'acquisition sur-mesure pour développer votre chiffre d'affaires.",

    introduction: {
      title: "Le digital : votre meilleur commercial",
      content: `Le marketing digital n'est plus une option – c'est le canal d'acquisition le plus rentable pour la majorité des entreprises.

Pourquoi investir dans le marketing digital ?
• Un ROI mesurable à l'euro près
• Une audience hyper-ciblée selon vos critères
• Des résultats traçables en temps réel
• Une scalabilité infinie selon vos moyens

Notre approche : data-driven, test & learn, optimisation continue. Chaque euro investi doit rapporter.`,
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800",
      stats: [
        { value: "x5", label: "ROI moyen du marketing digital" },
        { value: "97%", label: "des recherches commencent sur Google" },
        { value: "4.6Md", label: "d'utilisateurs sur les réseaux sociaux" }
      ]
    },

    channels: {
      title: "Nos Expertises Marketing",
      items: [
        {
          name: "SEO - Référencement Naturel",
          description: "Dominez les résultats Google sur vos mots-clés stratégiques. Trafic qualifié et durable.",
          benefits: ["Trafic gratuit et qualifié", "Crédibilité renforcée", "ROI long terme"],
          icon: "Search"
        },
        {
          name: "Google Ads",
          description: "Soyez visible instantanément sur Google. Contrôlez votre budget et votre ROI au centime près.",
          benefits: ["Résultats immédiats", "Ciblage précis", "Budget maîtrisé"],
          icon: "Target"
        },
        {
          name: "Social Media Ads",
          description: "Touchez votre audience idéale sur Facebook, Instagram, LinkedIn avec des pubs ultra-ciblées.",
          benefits: ["Ciblage démographique", "Formats engageants", "Retargeting"],
          icon: "Users"
        },
        {
          name: "Email Marketing",
          description: "Fidélisez vos clients et automatisez vos ventes avec des séquences emails performantes.",
          benefits: ["ROI de 4200%", "Relation personnalisée", "Automatisation"],
          icon: "Mail"
        }
      ]
    },

    faq: [
      {
        question: "Combien de temps pour voir des résultats SEO ?",
        answer: "Le SEO est un investissement moyen/long terme. Les premiers résultats apparaissent généralement entre 3 et 6 mois, avec une croissance continue ensuite. En local (Istres, Marseille...), les résultats peuvent être plus rapides."
      },
      {
        question: "Quel budget pour Google Ads ?",
        answer: "Nous recommandons un minimum de 500€/mois de budget publicitaire pour commencer, plus nos frais de gestion. Le budget optimal dépend de votre secteur et vos objectifs. Nous optimisons chaque euro pour maximiser votre ROI."
      },
      {
        question: "Gérez-vous nos réseaux sociaux ?",
        answer: "Oui ! Nous proposons des forfaits de community management incluant la création de contenus, la planification, la modération et le reporting. Nous pouvons aussi vous former pour être autonome."
      }
    ],

    gallery: [
      { src: "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=800", alt: "Analytics" },
      { src: "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=800", alt: "Social media" }
    ]
  }
};

// Blog articles data
export const BLOG_ARTICLES = [
  {
    id: 1,
    slug: "pourquoi-site-internet-2024",
    title: "Pourquoi avoir un site internet en 2024 est indispensable",
    excerpt: "81% des consommateurs recherchent en ligne avant d'acheter. Découvrez pourquoi votre présence digitale est cruciale.",
    category: "Web",
    author: "Jeremy",
    date: "2024-01-15",
    readTime: "5 min",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800",
    tags: ["Site web", "Digital", "Business"]
  },
  {
    id: 2,
    slug: "guide-seo-debutant",
    title: "Le guide SEO complet pour les débutants",
    excerpt: "Tout ce que vous devez savoir pour bien référencer votre site sur Google. Les bases du SEO expliquées simplement.",
    category: "Marketing",
    author: "Jade",
    date: "2024-01-10",
    readTime: "12 min",
    image: "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?w=800",
    tags: ["SEO", "Google", "Référencement"]
  },
  {
    id: 3,
    slug: "tendances-logo-2024",
    title: "Les tendances logo et branding en 2024",
    excerpt: "Minimalisme, dégradés, typographies audacieuses... Découvrez les tendances graphiques qui marqueront cette année.",
    category: "Graphique",
    author: "Julien",
    date: "2024-01-05",
    readTime: "7 min",
    image: "https://images.unsplash.com/photo-1626785774625-0b1c2c4eab67?w=800",
    tags: ["Logo", "Design", "Tendances"]
  },
  {
    id: 4,
    slug: "video-marketing-roi",
    title: "Vidéo marketing : le format roi pour votre ROI",
    excerpt: "La vidéo génère 1200% plus de partages. Comment l'intégrer efficacement dans votre stratégie marketing ?",
    category: "Vidéo",
    author: "Loan",
    date: "2024-01-01",
    readTime: "8 min",
    image: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800",
    tags: ["Vidéo", "Marketing", "ROI"]
  },
  {
    id: 5,
    slug: "wordpress-vs-autres-cms",
    title: "WordPress vs Wix vs Shopify : quel CMS choisir ?",
    excerpt: "Comparatif complet des plateformes pour créer votre site. Avantages, inconvénients, prix... On vous dit tout.",
    category: "Web",
    author: "Anthony",
    date: "2023-12-20",
    readTime: "10 min",
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800",
    tags: ["WordPress", "CMS", "Comparatif"]
  },
  {
    id: 6,
    slug: "reseaux-sociaux-entreprise",
    title: "Quels réseaux sociaux pour mon entreprise ?",
    excerpt: "Facebook, Instagram, LinkedIn, TikTok... Où devez-vous être présent ? Guide pour choisir les bons canaux.",
    category: "Marketing",
    author: "Jade",
    date: "2023-12-15",
    readTime: "6 min",
    image: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=800",
    tags: ["Réseaux sociaux", "Stratégie", "B2B"]
  }
];

// General FAQ
export const GENERAL_FAQ = [
  {
    category: "Général",
    questions: [
      {
        question: "Où êtes-vous situés ?",
        answer: "Notre siège social est situé au 52 Rue des Pétouses, 13800 Istres (nous ne recevons pas de public à cette adresse). Nous intervenons sur toute la région PACA et au-delà grâce au télétravail."
      },
      {
        question: "Travaillez-vous uniquement avec des entreprises locales ?",
        answer: "Non ! Si nous adorons accompagner les entreprises de notre région (Istres, Martigues, Salon, Marseille...), nous travaillons avec des clients dans toute la France et même à l'international."
      },
      {
        question: "Comment se déroule un projet avec vous ?",
        answer: "Tout commence par un échange gratuit pour comprendre vos besoins. Nous vous envoyons ensuite un devis détaillé. Si OK, on lance le projet avec un planning clair et des points réguliers jusqu'à la livraison."
      }
    ]
  },
  {
    category: "Tarifs & Paiement",
    questions: [
      {
        question: "Comment sont calculés vos tarifs ?",
        answer: "Nos tarifs dépendent de la complexité du projet, du temps nécessaire et des livrables souhaités. Nous établissons toujours un devis détaillé et transparent avant de commencer."
      },
      {
        question: "Proposez-vous des facilités de paiement ?",
        answer: "Oui ! Nous proposons un paiement en 3x sans frais : 40% à la commande, 30% à mi-projet, 30% à la livraison. Pour les gros projets, nous pouvons étudier des échéanciers personnalisés."
      },
      {
        question: "Acceptez-vous le paiement par carte ?",
        answer: "Absolument ! Nous acceptons les virements bancaires, les CB (via Stripe), et même PayPal pour les clients internationaux."
      }
    ]
  },
  {
    category: "Support & Suivi",
    questions: [
      {
        question: "Que se passe-t-il après la livraison ?",
        answer: "Nous restons disponibles ! Tous nos projets incluent une période de garantie. Nous proposons aussi des forfaits de maintenance et support pour vous accompagner sur le long terme."
      },
      {
        question: "Êtes-vous réactifs en cas de problème ?",
        answer: "La réactivité est notre marque de fabrique ! Nous répondons sous 24h max aux emails, et nos clients en maintenance ont un numéro direct pour les urgences."
      }
    ]
  }
];
